module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"h1":"Регистрация успешно завершена!"}}')
  delete Component.options._Ctor
}
